<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">{{ title }}</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Title</label>
            <input
              name="title"
              v-model="newTemplate.title"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="title"
              v-validate="'required'"
            />
            <help-block field="title" />
          </div>

          <div class="mb-3">
            <label class="control-label">Type</label>
            <multiselect
              :show-labels="false"
              v-model="newTemplate.type"
              :options="types"
              placeholder="Select Type"
              v-validate="'required'"
              data-vv-name="type"
            ></multiselect>
            <help-block field="type" />
          </div>

          <h3 class="mt-4">Cover &amp; Footer</h3>

          <div class="mb-3">
            <label class="control-label">Cover Header 1</label>
            <textarea v-model="newTemplate.cover_header_1" class="form-control" rows="4"></textarea>
          </div>

          <div class="mb-3">
            <label class="control-label">Cover Header 2</label>
            <textarea v-model="newTemplate.cover_header_2" class="form-control" rows="4"></textarea>
          </div>

          <div class="mb-3">
            <label class="control-label">Footer</label>
            <textarea v-model="newTemplate.footer" class="form-control" rows="4"></textarea>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'
import { cloneDeep } from 'lodash'
import Multiselect from 'vue-multiselect'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },

  extends: CModal,

  props: ['title', 'template'],

  components: {
    Multiselect
  },

  data () {
    return {
      newTemplate: {},
      types: [
        'Signoff',
        'Opportunity',
        'Variation',
        'SourceCode',
        'NDA'
      ]
    }
  },

  mounted () {
    this.addEventListener('open', () => {
      this.newTemplate = cloneDeep(this.template)
    })
  },

  methods: {
    ...mapActions('signRequestTemplate', ['addSingle', 'updateSingle']),

    async handleSave () {
      if (!(await this._validate())) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return Promise.reject()
      }

      const request = this.newTemplate.id
        ? this.updateSingle({ id: this.newTemplate.id, payload: this.newTemplate })
        : this.addSingle(this.newTemplate)

      return request.then((response) => {
        if (this.newTemplate.id) {
          notify.success('Template successfully updated.')
          this.$emit('updated', response.data)
        } else {
          // Wait until the modal has hidden as the parent navigates away on create,
          // destroying the modal before bootstrap can remove the backdrop
          this.$once('closed', () => this.$emit('created', response.data))
        }

        this.close()
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          notify.error('Form validation failed, please check your inputs and try again.')
        } else {
          console.error(error)
          notify.error('Failed to save template, please try again.')
        }
      })
    }
  }
}
</script>
